export default __webpack_public_path__ + "static/media/sponsors-rollup.735614fc.jpg";